import type { SportRulesType } from '@/components/RulesModal';

/** Notice shown above the exchange rules. */
export const generalRulesNotice = `PLEASE READ OUR RULES BEFORE PLACING BET ** ONCE OUR EXCHANGE GIVE USERNAME AND PASSWORD, IT IS YOUR RESPONSIBILITY TO CHANGE THE PASSWORD.`;

/**
 * Exchange-wide rules, copied word for word from the client's text (keep it that way: edit the
 * wording only when they send a new version). Red rows are the key ones. Line breaks inside a
 * row are kept on screen.
 */
export const generalRules: SportRulesType = {
  sections: [
    {
      title: '1) CHEAT RULES: -',
      rows: [
        {
          text: `1.1) In Betfair & Fancy markets, If anyone is suspected using ground commentary or ground line or courtsiding(being in ground while betting), company will void all winning bets(without providing any proof). This is a zero tolerance policy and no arguments will be entertained. The bets will be voided after the match is completed. Company's decision will be final decision.`,
          danger: true,
        },
      ],
    },
    {
      title: '2) MATCH ODDS RULES: -',
      rows: [
        { text: `2.1) Cricket: We will follow Betfair result.` },
        { text: `2.2) Soccer: We will follow Betfair result.` },
        { text: `2.3) Tennis: We will follow Betfair result.` },
        {
          text: `2.4) IF Any Client Found Hedging Or Doing Manipulation in Any Match Odds, then company has the right to Void the Bets.`,
          danger: true,
        },
        {
          text: `2.5) If Exchange resettle any bets or Markets due to wrong Result Declaration or any other reason & if the Player has lost Money or If Player gets Negative Balance, In this case Company will do the Settlement from Agent for the same, all decision will be Full And Final, No Arguments will be listened.`,
        },
        {
          text: `2.6) Company reserves the right to void any bets (only winning bets) of any event at any point of the match if the company believes there is any cheating/wrong doing in that particular event by the players (either batsman/bowler).`,
        },
      ],
    },
    {
      title: '3) BOOKMAKER MARKET RULES: -',
      rows: [
        {
          text: `3.1) Due to any reason any team will be getting advantage or disadvantage we are not concerned.`,
        },
        {
          text: `3.2) Wrong team selection by our mistake all back and lays bets will be deleted.`,
        },
        { text: `3.3) wrong rate bets also voided.` },
        {
          text: `3.4) If Exchange resettle any bets or Markets due to wrong Result Declaration or any other reason & if the Player has lost Money or If Player gets Negative Balance, In this case Company will do the Settlement from Agent for the same, all decision will be Full And Final, No Arguments will be listened.`,
        },
        {
          text: `3.5) Company reserves the right to void any bets (only winning bets) of any event at any point of the match if the company believes there is any cheating/wrong doing in that particular event by the players (either batsman/bowler).`,
        },
        {
          text: `3.6) If both the teams score same runs in 4,6,10,15 overs & 25 Balls Bookmaker the team that first bated will be declared as the winner.`,
        },
      ],
    },
    {
      title: '4) FANCY:-',
      rows: [
        {
          text: `4.1) Advance fancy: - Advance Session, Player Runs and all Fancy Bets are only valid for 20 Over/50 Over full match each side. (Please Note this condition is applied only in case of Advance Fancy Bets only).`,
        },
        {
          text: `4.2) All advance fancy bets market will be suspended 60 mins prior to match and will be settled.`,
        },
        { text: `4.3) Advance session and Lambi 1st inning valid only.` },
        {
          text: `4.4) Total match playing over adv: - We Will Settle this Market after Whole Match gets Completed.`,
        },
        {
          text: `4.5) Criteria: - We Will Count Only Round- Off Over For Both the Innings While Settling (For Ex: - If 1st Batting team gets all out at 17.3, 18.4 or 19.5 we Will Count Such Overs as 17, 18 and 19 Respectively and if Match gets Ended at 17.2, 18.3 or 19.3 Overs then we will Count that as 17, 18 and 19 Over Respectively... and this Will Remain Same For Both the Innings.`,
        },
        {
          text: `4.6) In Case of Rain or if Over gets Reduced then this Market will get Voided.`,
        },
        {
          text: `4.7) 3 Wkt or more by bowler in match adv:- We Will Settle this Market after Whole Match gets Completed.`,
        },
        {
          text: `4.8) Once all session/fancy bets are completed and settled there will be no reversal even if the Match is Tied or is Abandoned.`,
        },
        {
          text: `4.9) Under the rules of Session/Fancy Bets if a market gets Suspended for any reason whatsoever and does not resume then all previous Bets will remain Valid and become HAAR/JEET bets.`,
        },
        {
          text: `4.10) Incomplete Session/Fancy Bet will be cancelled but Complete Session will be settled.`,
        },
        {
          text: `4.11) In the case of Running Match getting Cancelled/ No Result/ Abandoned but the session is complete it will still be settled. Player runs / fall of wicket/Wicket lost to ball/How many ball face by player will be also settled at the figures where match gets stopped due to rain for the inning (D/L) , cancelled , abandoned , no result.`,
        },
        {
          text: `4.12) If a player gets Retired Hurt and one ball is completed after you place your bets then all the betting till then is and will remain valid.`,
        },
        {
          text: `4.13) Should a Technical Glitch in Software occur, we will not be held responsible for any losses.`,
        },
        {
          text: `4.14) Should there be a power failure or a problem with the Internet connection at our end and session/fancy market does not get suspended then our decision on the outcome is final.`,
        },
        {
          text: `4.15) All decisions relating to settlement of wrong market being offered will be taken by management. Management will consider all actual facts and decision taken will be full in final.`,
        },
        {
          text: `4.16) Any bets which are deemed of being suspicious, including bets which have been placed from the stadium or from a source at the stadium maybe void at anytime. The decision of whether to void the particular bet in question or to void the entire market will remain at the discretion of Company. The final decision of whether bets are suspicious will be taken by Company and that decision will be full and final.`,
        },
        {
          text: `4.17) Any sort of cheating bet, any sort of Matching (Passing of funds), Court Siding (Ghaobaazi on commentary), Sharpening, Commission making is not allowed in Company, If any company User is caught in any of such act then all the funds belonging that account would be seized and confiscated. No argument or claim in that context would be entertained and the decision made by company management will stand as final authority.`,
          danger: true,
        },
        {
          text: `4.18) If any case wrong rate has been given in fancy,that particular bets will be cancelled (Wrong Commentary).`,
        },
        {
          text: `4.19) In case customer make bets in wrong fancy we are not liable to delete, no changes will be made and bets will be considered as confirm bet.`,
        },
        {
          text: `4.20) any query regarding result or rate has to be contacted within 7 days from the event, query after 7 days from the event will not be considered as valid.`,
        },
        {
          text: `4.21) The Rules Which we have added Regarding Cheating/Hedging/manipulation of Odds are ONLY for the Ones with Wrong Intensions Not for Genuine Clients.`,
        },
        {
          text: `4.22) Penalty Runs - Any Penalty Runs Awarded in the Match (In Any Running Fancy or ADV Fancy) Will Not be Counted While Settling in our Exchange.`,
        },
        {
          text: `4.23) Player Boundaries Fancy:- We will only consider Direct Fours and Sixes hit by BAT.`,
        },
        {
          text: `4.24) Bowler run session rule:- If Bowler Bowl 1.1 over,then valid(For Bowler 2 over runs session) If Bowler Bowl 2.1 over,then valid(For Bowler 3 over runs session) If Bowler Bowl 3.1 over,then valid(For Bowler 4 over runs session) If Bowler Bowl 4.1 over,then valid(For Bowler 5 over runs session) If Bowler Bowl 9.1 over,then valid(For Bowler 10 over runs session)`,
        },
        {
          text: `4.25) Any cricket event which is being held behind closed doors in that if any players found to be taking advantage of groundline in fancy bets in such cases bets can be void after the market ends. Company decision to be final.`,
        },
        {
          text: `4.26) Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example,In case of VPN/robot-use/multiple entry from same IP/ multiple bets at same time (Punching) and others. Note: - only winning bets will be voided, For example: If we find such entries (above mentioned) from any id and their bets are (200000 lay in a 6 over session for the rate 40 and 200000 back for the rate of 48) and the actual score is 38, bets of 40 lay will be voided and the bets for 48 back will be considered valid.`,
          danger: true,
        },
        {
          text: `4.27) Odd-even rules:- Incomplete games will be deleted. Over reduced or abandoned all bets will be deleted.`,
        },
        { text: `4.28) In any circumstances company decision will be final.` },
        {
          text: `4.29) If Users Found Betting In Group's then We Will Void "Only The Winning Bets of the Users" and Company Decision Will be Full and Final.`,
          danger: true,
        },
        {
          text: `4.30) If Exchange resettle any bets or Markets due to wrong Result Declaration or any other reason & if the Player has lost Money or If Player gets Negative Balance, In this case Company will do the Settlement from Agent for the same, all decision will be Full And Final, No Arguments will be listened.`,
        },
        {
          text: `4.31) Company reserves the right to void any bets (only winning bets) of any event at any point of the match if the company believes there is any cheating/wrong doing in that particular event by the players (either batsman/bowler)`,
        },
        { text: `4.32) Our Exchange Is Trusted and Fair.` },
      ],
    },
    {
      title: '5) IPL RULES:-',
      rows: [
        {
          text: `5.1) If Over Reduced in Match, we will not count the actual scores of the Over Reduced Matches instead we will count the Market’s Average Scores.`,
        },
        {
          text: `5.2) If Match is Abandoned, we will not count the actual scores of the Abandoned Matches instead we will count the Market’s Average Scores. NOTE:-These rules are for the following Markets of ENTIRE IPL 2021 (60 Matches):-`,
        },
        {
          text: `5.3) Total Fours: - Average 26 Fours will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.4) Total Sixes: - Average 13 Sixes will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.5) Total Wide: - Average 8 Wide’s will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.6) Total Extras: - Average 14 Extras will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.7) Total No Ball: - Average 1 No Ball will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.8) Total Duck: - Average 1 Duck will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.9) Total Fifties: - Average 2 Fifties will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.10) Total Century: -Average 0 Century will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.11) Total Run Out: - Average 1 Run Out will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.12) Total Caught out: - Average 8 Caught Out will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.13) Total Maiden Over: - Average 0 Maiden Over will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.14) Total LBW: - Average 1 LBW will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.15) Total Bowled: - Average 2 Bowled will be given if the match is abandoned or over reduced.`,
        },
        {
          text: `5.16) Total Match 30 ADV: - If a player reached 50 means, Not considered in this Event.`,
        },
        {
          text: `5.17) Total Match 50 ADV: - If a player reached 100 means, Not considered in this Event.`,
        },
        {
          text: `5.18) In case IPL Matches Gets Stopped or Interrupted Due to "COVID-19" or Any "ACT OF GOD" Reasons, under 45 Matches then All IPL 2021 Tournament Fancy Markets will be Voided, but if 45 or Above Matches are Being Played then we will Settle all the Fancy Markets and Also If there are NON-Played Matches Above 45 then we will settle the markets as per our Markets Average.`,
        },
        {
          text: `5.19) If IPL 2021 gets stopped due to “Covid-19” or Any “Act of God” reason then We will wait till 45 days from the day IPL gets stopped, and if IPL Matches gets Resumed before 45th day then we will continue as Usual Score Countation but if IPL 2021 does not resume until 45th day then we will settle the markets according to our above-mentioned Markets Averages and In case of Void, We will Void the under 45 matches on 45th day from the day IPL 2021 stopped.`,
        },
        {
          text: `5.20) Middle session and Session is not completed due to Innings declared or all out so that particular over considered as completed and remaining over counted in next team Innings for ex:- In case of Innings declared or all out In 131.5th over Considered as 132 over completed remaining 1 over counted for 133 over middle session and 3 over counted for 135 over session from next team Innings and One over session and Only over session is not completed due to innings declared so that Particular over session bets will be deleted and all out considered as valid for ex:- In case of Innings declared In 131.5th over so 132 over will be deleted and if all out then 132 over and Only 132 over will be Valid.`,
        },
      ],
    },
    {
      title: '6) Casino RULES:-',
      rows: [
        {
          text: `6.1) If Company voided any bet due to wrong rate or technical issue in casino games and the Player has lost Money or If Player gets Negative Balance, In this case Company will do the Settlement from Agent for the same, all decision will be Full And Final, No Arguments will be listened.`,
        },
        {
          text: `6.2) Exchange accept maximum bet as per below casino:

Evolution: 2,00,000 INR

Pragmatic: 2,00,000 INR

Bet Games: 2,00,000 INR

Vivo: 2,00,000 INR`,
        },
      ],
    },
    {
      title: '7) Color Bets',
      rows: [
        {
          text: `7.1) Any kind of market color bets shall be voided and all available balance shall be confesticated for placing bets with wrong intentions on our system`,
          danger: true,
        },
        {
          text: `7.2) Desicion of whether it’s a color bet or not is 100% of the company and no disputes or explanation or arguments shall be entertained what so ever`,
        },
        { text: `7.3) No written proof or mails shall be provided for the same` },
        {
          text: `7.4) Casino Maximum Win Limit (100× Cap)

To manage risk and ensure fair play, a maximum win cap applies to all casino games. The maximum payout per game round is capped at 100× the original stake placed for that round. If a game round generates winnings exceeding 100× the stake, only 100× the stake amount will be credited to the user’s balance.
Any winnings above the 100× cap will be automatically removed/adjusted by the system.

Example: Stake: ₹100
Game Result: 250× win (₹25,000)
Maximum allowed win: 100× (₹10,000)
Amount credited: ₹10,000

Remaining ₹15,000 will be voided.
This rule applies to all casino games unless otherwise stated.`,
          danger: true,
        },
      ],
    },
  ],
};
